import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //APIbase: 'http://localhost:8081/src',
    APIbase: 'https://link-aid.sakura.ne.jp/credit/api.php',
    userName: '',
    role: '',
  },
  mutations: {
    setUserName(state, userName){
      state.userName = userName;
    },
    setRole(state, role){
      state.role = role;
    }
  },
  actions: {
    setUserName({commit}, userName){
      commit("setUserName", userName);
    },
    setRole({commit}, role){
      commit("setRole", role);
    }
  },
  modules: {
  }
})
